import { HexColorPicker } from "react-colorful";
import { SyncControls } from "./sync-controls";
import { cn } from "@/lib/utils";
import { Input, PopoverPanel } from "@headlessui/react";
import { SyncControlsPrimary } from "./sync-controls-primary";
import { useColorUpdate } from "@/hooks/use-color-update";
import React, { useEffect, useState, useRef } from "react";
import { useSetAtom } from "jotai";
import { shortcutsDisabled } from "@/hooks/use-theme-shortcuts";
import Color from "color";
import { createPortal } from "react-dom";
import { useHasPhysicalKeyboard } from "@/hooks/use-has-keyboard";
export const ColorPickerPanel = ({
  colorKey,
  width
}) => {
  const {
    colorPalette,
    updateColor
  } = useColorUpdate();
  const hasPhysicalKeyboard = useHasPhysicalKeyboard();
  const [colorInput, setColorInput] = useState("");
  const inputElementRef = useRef(null);
  const setShortcutsDisabled = useSetAtom(shortcutsDisabled);
  const handleColorInputChange = value => {
    // Validate hex color length
    if (value.startsWith("#") && value.length > 7) {
      return;
    }

    // Update the text input
    setColorInput(value);
    try {
      // Only process complete hex colors or non-hex color values
      const isValidHex = value.startsWith("#") && value.length === 7;
      const isNonHexColor = !value.startsWith("#");
      if (isValidHex || isNonHexColor) {
        const colorObj = Color(value);
        updateColor(colorKey, colorObj.hex());
      }
    } catch {
      // Invalid color format - keep the current input value
      console.debug("Invalid color format:", value);
    }
  };
  useEffect(() => {
    inputElementRef.current = document.getElementById(`${colorKey}-color-input`);
  }, [colorKey]);
  useEffect(() => {
    setColorInput(colorPalette[colorKey]);
  }, [colorPalette, colorKey]);
  return <PopoverPanel anchor={{
    to: "bottom",
    padding: 16
  }} as="div" className={cn("bg-border/75 -mt-px w-[min(var(--popover-width),300px)] !overflow-visible backdrop-blur-xl", "shadow-2xl shadow-neutral-900/10", "inset-ring-border inset-ring")} style={{
    "--popover-width": `${Math.min(width, 300)}px`
  }}>
      {/* portal to the <div id={`${colorKey}-color-input`} /> */}
      {!!inputElementRef.current && createPortal(<div className="-mt-[0.5px]">
            <Input className="text-muted-foreground font-mono font-light uppercase outline-none focus:outline-none data-focus:-outline-offset-2 data-focus:outline-blue-500 data-focus:outline-none" value={colorInput} onChange={e => handleColorInputChange(e.target.value)} onFocus={e_0 => {
        setShortcutsDisabled(true);
        e_0.target.select();
      }} onBlur={() => {
        setShortcutsDisabled(false);
      }} placeholder={colorPalette[colorKey]} autoFocus={hasPhysicalKeyboard} />
          </div>, inputElementRef.current)}
      <HexColorPicker color={colorPalette[colorKey]} onChange={value_0 => handleColorInputChange(value_0)} />

      {colorKey === "primary" ? <SyncControlsPrimary /> : <SyncControls colorKey={colorKey} />}
    </PopoverPanel>;
};